module.exports = __webpack_public_path__ + "img/magic-scroll.e0413ee6.svg";